import { EstadoCesionType } from "api/Types/EstadoCesion"

export const CESIONES_DEFAULT_STATUS: Omit<EstadoCesionType[], number> = [
  1, 2, 4, 7,
]
